/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Save_ButtonInputs */

const en_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const fr_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

const ru_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранять`)
};

const es_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorrar`)
};

const zh_cn2_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省`)
};

const ja_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const hi_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचाना`)
};

const pt_pt2_explorer_display_save_button = /** @type {(inputs: Explorer_Display_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Explorer_Display_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_save_button = /** @type {((inputs?: Explorer_Display_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_save_button(inputs)
	if (locale === "de") return de_explorer_display_save_button(inputs)
	if (locale === "it") return it_explorer_display_save_button(inputs)
	if (locale === "ru") return ru_explorer_display_save_button(inputs)
	if (locale === "es") return es_explorer_display_save_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_save_button(inputs)
	if (locale === "ja") return ja_explorer_display_save_button(inputs)
	if (locale === "hi") return hi_explorer_display_save_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_save_button(inputs)
	return en_explorer_display_save_button(inputs)
});